var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brief-content-view" },
    [
      _c("SelectFolderModalToolbar", {
        attrs: { value: _vm.searchKey },
        on: {
          input: function ($event) {
            _vm.searchKey = $event
          },
          clear: function ($event) {
            _vm.searchKey = ""
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "breadcrumb",
              fn: function () {
                return [_vm._t("breadcrumb", null, { title: _vm.briefTitle })]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "brief-content-view__state" },
            [_c("b-spinner")],
            1
          )
        : _vm.visibleItems.length === 0
        ? _c("div", { staticClass: "brief-content-view__state" }, [
            _vm._v("\n    " + _vm._s(_vm.emptyStateText) + "\n  "),
          ])
        : _c("ItemGrid", {
            staticClass: "brief-content-view__grid",
            attrs: {
              items: _vm.visibleItems,
              "is-selected": _vm.isSelected,
              "item-props": { showCheckbox: true, showDownloadIcon: true },
            },
            on: { "item-click": _vm.toggleSelect, download: _vm.downloadItem },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }